import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import SortableTable from '../../molecules/SortableTable';
import { Action, Label, TableRow } from '../../atoms';
import { IndicatorResponseDto } from '../../../store/landscapeAPI/indicator/dto/response/indicator-response.dto';

interface ReportingDetailsIndicatorsOrganismProps {
  data: IndicatorResponseDto[];
  handleDeleteIndicator: (id: string) => void;
}

const ReportingDetailsIndicatorsOrganism: FC<
  ReportingDetailsIndicatorsOrganismProps
> = ({ data, handleDeleteIndicator }) => {
  const navigate = useNavigate();

  const handleUpdateIndicator = (id: string) => {
    navigate(`/reporting-details/indicators/${id}/edit`);
  };

  return (
    <SortableTable
      data={data}
      columns={[{ label: 'Indicators', key: 'name' }]}
      renderRow={(row) => (
        <TableRow key={row.id}>
          <Label content={row.name} />
          <Action
            type="edit"
            size="sm"
            onClick={() => handleUpdateIndicator(row.id)}
          />
          <Action
            type="delete"
            itemName={row.name}
            size="sm"
            onClick={() => handleDeleteIndicator(row.id)}
          />
        </TableRow>
      )}
    />
  );
};

export default ReportingDetailsIndicatorsOrganism;
